import { ActionTypes } from "../constants/action-types";
import { createAction } from "redux-actions";
import { countUnreadNotifications } from "../api/NotificationApi";

const api = {
  [ActionTypes.showAppNav]: (data) => data,
  [ActionTypes.setNotification]: (data) => data,
  [ActionTypes.clearNotification]: () => {},
  [ActionTypes.countUnreadNotification]: (userId: string) => countUnreadNotifications(userId),
  [ActionTypes.hoverDataItem]: (data) => data,
};

const actions: any = { ...api };

Object.keys(actions).forEach((type) => {
  actions[type] = createAction(type, actions[type]);
});

export default actions;
